// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEvent_root__3ndey"};